class SimpleMegaMenu {
  constructor() {
    this.init();
  }

  init() {
    // Wait a bit for the DOM to be fully ready
    setTimeout(() => {
      this.enhanceAllMegaMenus();
    }, 100);
  }

  enhanceAllMegaMenus() {
    // Find all mega menus and enhance them
    const megaMenus = document.querySelectorAll('.mega-menu');
    console.log('Found mega menus:', megaMenus.length);
    
    megaMenus.forEach((menu, index) => {
      console.log(`Enhancing mega menu ${index + 1}`);
      this.enhanceMegaMenu(menu);
    });
  }

  enhanceMegaMenu(menu) {
    const subcategoryLinks = menu.querySelectorAll('.mega-menu__subcategory-link');
    const subsubcategoryGroups = menu.querySelectorAll('.mega-menu__subsubcategory-group');
    const featuredItems = menu.querySelectorAll('.mega-menu__featured-item');
    
    console.log('Subcategory links found:', subcategoryLinks.length);
    console.log('Subsubcategory groups found:', subsubcategoryGroups.length);
    console.log('Featured items found:', featuredItems.length);
    
    if (subcategoryLinks.length === 0) {
      console.log('No subcategory links found, skipping enhancement');
      return;
    }

    // Add event listeners for subcategory hover
    subcategoryLinks.forEach((link, index) => {
      console.log(`Adding hover listener to subcategory ${index + 1}:`, link.textContent.trim());
      
      link.addEventListener('mouseenter', (event) => {
        console.log('Subcategory hovered:', event.target.textContent.trim());
        this.switchContent(link, subsubcategoryGroups, featuredItems);
      });
    });
  }

  switchContent(activeLink, subsubcategoryGroups, featuredItems) {
    const subcategoryHandle = activeLink.getAttribute('data-subcategory');
    console.log('Switching to subcategory:', subcategoryHandle);
    
    // Remove active class from all subcategory links
    document.querySelectorAll('.mega-menu__subcategory-link').forEach(link => {
      link.classList.remove('mega-menu__subcategory-link--active');
    });

    // Add active class to hovered link
    activeLink.classList.add('mega-menu__subcategory-link--active');

    // Hide all subsubcategory groups
    subsubcategoryGroups.forEach(group => {
      group.classList.remove('mega-menu__subsubcategory-group--active');
    });

    // Hide all featured items
    featuredItems.forEach(item => {
      item.classList.remove('mega-menu__featured-item--active');
    });

    // Show the target subsubcategory group
    const targetSubsubcategoryGroup = document.querySelector(`[data-subcategory="${subcategoryHandle}"].mega-menu__subsubcategory-group`);
    if (targetSubsubcategoryGroup) {
      console.log('Found target subsubcategory group, showing it');
      targetSubsubcategoryGroup.classList.add('mega-menu__subsubcategory-group--active');
    }

    // Show the target featured item
    const targetFeaturedItem = document.querySelector(`[data-subcategory="${subcategoryHandle}"].mega-menu__featured-item`);
    if (targetFeaturedItem) {
      console.log('Found target featured item, showing it');
      targetFeaturedItem.classList.add('mega-menu__featured-item--active');
    }
  }
}

// Initialize the simple mega menu
function initializeSimpleMegaMenu() {
  console.log('Initializing SimpleMegaMenu');
  new SimpleMegaMenu();
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initializeSimpleMegaMenu);

// Also initialize if the script loads after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeSimpleMegaMenu);
} else {
  initializeSimpleMegaMenu();
}

// Re-initialize when mega menus are opened (for dynamic content)
document.addEventListener('click', (event) => {
  if (event.target.closest('.mega-menu summary')) {
    setTimeout(() => {
      console.log('Mega menu opened, re-initializing simple mega menu');
      new SimpleMegaMenu();
    }, 200);
  }
});

// Also listen for when mega menus are opened via details element
document.addEventListener('toggle', (event) => {
  if (event.target.classList.contains('mega-menu') && event.target.open) {
    setTimeout(() => {
      console.log('Mega menu details opened, re-initializing simple mega menu');
      new SimpleMegaMenu();
    }, 100);
  }
});
